export default "__VITE_ASSET__BkGxOI4v__"